// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sources {
  flex-grow: 1;
  transition: 0.25s;
  padding: 0 10px 10px;
}  

.sources .MuiDataGrid-root {
  font-weight: unset;
  font-family: unset;
  line-height: unset;
  letter-spacing: unset;
  border-radius: var(--radius-medium);
  flex: 1 1;
  color: rgba(0, 0, 0, 0.87);
  border: 1px solid rgba(224, 224, 224, 1);
  height: 100%;
  display: flex;
  outline: none;
  position: relative;
  font-size: 0.875rem;
  box-sizing: border-box;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 400;
  line-height: 1.43;  
  flex-direction: column;
  letter-spacing: 0.01071em;
}

.sources .MuiDataGrid-main {
  gap: 10px;
  display: flex;
  flex-direction: column;
  
  min-height: 0;
  /* padding: 20px 30px; */
  overflow: hidden auto;
}

@supports (-moz-appearance: none) {
  /*
    Give the scrollbar 10px margin on Firefox
    since it doesn't support custom scrollbar
  */
  .sources .MuiDataGrid-main {
    /* padding: 20px; */
    margin: 0 10px;
  }
}



.sources .content__header .options .button:not(.icon) {
  background-color: var(--button-bg-darker);
}

.sources .prompt__container .sidebar__select {
  padding: 0;
}

.sources.group .prompt__backdrop {
  z-index: 0;
  height: 100%;
  position: unset;
  background: white;
}

.sources.group .prompt__backdrop>.prompt__container {
  box-shadow: 0 0 15px 5px var(--button-bg-darker);
}


/* IP Address + Port Number text input */

.sources .prompt__container .loc__port input[type="numeric"],
.sources .prompt__container .loc__port input[type="numeric"] {
  outline: 0;
  border: none;
  max-width: 40px;
  margin-right: 2px;
  text-align: center;
}


/* Print Report --- smaller for accounts and locations */

.sources:not(.groups) #print th,
.sources:not(.groups) #print td {
  font-size: 11px;
}



.sources .container__header {
  gap: 5px;
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr auto;
  justify-content: space-between;
}

.sources .container__title {
  font-size: 15x;
  transition: 0s;

  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;

  gap: 5px;
  flex-grow: 1;
  display: flex;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Dashboard/Sources/Sources.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,mCAAmC;EACnC,SAAO;EACP,0BAA0B;EAC1B,wCAAwC;EACxC,YAAY;EACZ,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,uDAAuD;EACvD,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,aAAa;EACb,sBAAsB;;EAEtB,aAAa;EACb,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE;;;GAGC;EACD;IACE,mBAAmB;IACnB,cAAc;EAChB;AACF;;;;AAIA;EACE,yCAAyC;AAC3C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gDAAgD;AAClD;;;AAGA,wCAAwC;;AAExC;;EAEE,UAAU;EACV,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;;AAGA,wDAAwD;;AAExD;;EAEE,eAAe;AACjB;;;;AAIA;EACE,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,cAAc;;EAEd,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;;EAEjB,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB","sourcesContent":[".sources {\r\n  flex-grow: 1;\r\n  transition: 0.25s;\r\n  padding: 0 10px 10px;\r\n}  \r\n\r\n.sources .MuiDataGrid-root {\r\n  font-weight: unset;\r\n  font-family: unset;\r\n  line-height: unset;\r\n  letter-spacing: unset;\r\n  border-radius: var(--radius-medium);\r\n  flex: 1;\r\n  color: rgba(0, 0, 0, 0.87);\r\n  border: 1px solid rgba(224, 224, 224, 1);\r\n  height: 100%;\r\n  display: flex;\r\n  outline: none;\r\n  position: relative;\r\n  font-size: 0.875rem;\r\n  box-sizing: border-box;\r\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n  font-weight: 400;\r\n  line-height: 1.43;  \r\n  flex-direction: column;\r\n  letter-spacing: 0.01071em;\r\n}\r\n\r\n.sources .MuiDataGrid-main {\r\n  gap: 10px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  \r\n  min-height: 0;\r\n  /* padding: 20px 30px; */\r\n  overflow: hidden auto;\r\n}\r\n\r\n@supports (-moz-appearance: none) {\r\n  /*\r\n    Give the scrollbar 10px margin on Firefox\r\n    since it doesn't support custom scrollbar\r\n  */\r\n  .sources .MuiDataGrid-main {\r\n    /* padding: 20px; */\r\n    margin: 0 10px;\r\n  }\r\n}\r\n\r\n\r\n\r\n.sources .content__header .options .button:not(.icon) {\r\n  background-color: var(--button-bg-darker);\r\n}\r\n\r\n.sources .prompt__container .sidebar__select {\r\n  padding: 0;\r\n}\r\n\r\n.sources.group .prompt__backdrop {\r\n  z-index: 0;\r\n  height: 100%;\r\n  position: unset;\r\n  background: white;\r\n}\r\n\r\n.sources.group .prompt__backdrop>.prompt__container {\r\n  box-shadow: 0 0 15px 5px var(--button-bg-darker);\r\n}\r\n\r\n\r\n/* IP Address + Port Number text input */\r\n\r\n.sources .prompt__container .loc__port input[type=\"numeric\"],\r\n.sources .prompt__container .loc__port input[type=\"numeric\"] {\r\n  outline: 0;\r\n  border: none;\r\n  max-width: 40px;\r\n  margin-right: 2px;\r\n  text-align: center;\r\n}\r\n\r\n\r\n/* Print Report --- smaller for accounts and locations */\r\n\r\n.sources:not(.groups) #print th,\r\n.sources:not(.groups) #print td {\r\n  font-size: 11px;\r\n}\r\n\r\n\r\n\r\n.sources .container__header {\r\n  gap: 5px;\r\n  display: grid;\r\n  grid-auto-flow: column;\r\n  grid-auto-columns: 1fr auto;\r\n  justify-content: space-between;\r\n}\r\n\r\n.sources .container__title {\r\n  font-size: 15x;\r\n  transition: 0s;\r\n\r\n  cursor: pointer;\r\n  user-select: none;\r\n\r\n  gap: 5px;\r\n  flex-grow: 1;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
